"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ResourceMenuItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _guacWidgetCore = require("@wsb/guac-widget-core");

var _ResourceHelper = _interopRequireDefault(require("../../utils/ResourceHelper"));

var _dataAids = _interopRequireDefault(require("../../constants/dataAids"));

var _withSize = _interopRequireDefault(require("../../utils/withSize"));

var _Truncate = _interopRequireDefault(require("../Truncate"));

var _resource = require("../../constants/propTypes/resource");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    padding: 'medium',
    cursor: 'pointer',
    textAlign: 'left'
  }
};

var ResourceMenuItem = function ResourceMenuItem(_ref) {
  var resource = _ref.resource,
      isMoreLinkVisible = _ref.isMoreLinkVisible,
      onResourceClick = _ref.onResourceClick,
      onClickMore = _ref.onClickMore,
      size = _ref.size,
      i18n = _ref.i18n;
  var _UX2$Element = _guacWidgetCore.UX2.Element,
      Text = _UX2$Element.Text,
      Details = _UX2$Element.Details,
      Card = _guacWidgetCore.UX2.Group.Card;
  return /*#__PURE__*/_react["default"].createElement(Card.Link, {
    style: styles.wrapper,
    onClick: function onClick() {
      return onResourceClick(resource);
    }
  }, /*#__PURE__*/_react["default"].createElement(Text, {
    "data-aid": _dataAids["default"].RESOURCE_MENU_ITEM_NAME
  }, _ResourceHelper["default"].getName(resource, {
    anyResourceName: i18n.anyResourceHeader,
    ownerResourceName: i18n.ownerResourceHeader
  })), resource.specialty && /*#__PURE__*/_react["default"].createElement(Details, {
    "data-aid": _dataAids["default"].RESOURCE_MENU_ITEM_SPECIALTY
  }, isMoreLinkVisible ? /*#__PURE__*/_react["default"].createElement(_Truncate["default"], {
    width: size.width,
    onClickMore: onClickMore,
    i18n: {
      expandCta: i18n.expandResourceBodyCta
    }
  }, resource.specialty) : resource.specialty));
};

exports.ResourceMenuItem = ResourceMenuItem;
ResourceMenuItem.propTypes = {
  resource: _resource.resourcePropType.isRequired,
  isMoreLinkVisible: _propTypes["default"].bool,
  onResourceClick: _propTypes["default"].func.isRequired,
  onClickMore: _propTypes["default"].func,
  size: _propTypes["default"].object.isRequired,
  i18n: _propTypes["default"].object.isRequired
};
ResourceMenuItem.defaultProps = {
  isMoreLinkVisible: false
};

var _default = (0, _withSize["default"])()(ResourceMenuItem);

exports["default"] = _default;